<div class="ratings-summary">
  <!-- HACK: Prevents the rating component from showing as focused -->
  <button class="hidden" autofocus></button>

  <rating [ngModel]="ratingDisplayValue" [max]="ratingDisplayMax" [readonly]="true"></rating>

  @if (hasNoRating) {
    <span>{{ noRatingsText | lhTranslate }}</span>
  } @else {
    <span class="average-rating">{{ averageRating | number: '1.1-1' }}</span>
    <span class="ratings-count">({{ numberOfRatings }})</span>
  }
</div>
